interface EmployeeTurnOver {
  month: string;
  turnoverRate: number;
}
interface Absentiesm {
  totalAbsent: number;
  year: number;
  month: number;
}

export interface EmployeeTurnOverRate {
  turnoverRates: {
    month: string;
    turnoverRate: number;
  }[];
}



export const dummyDataEmployeeTurnover: EmployeeTurnOverRate = {
  turnoverRates: [
    { month: "Jan", turnoverRate: 0 },
    { month: "Feb", turnoverRate: 0 },
    { month: "Mar", turnoverRate: 0 },
  ],
};


export interface TurnoverRateProps {
  count: number;
  reason: string;
}

export const dummyDataTurnoverRate = {
  count: 0,
  reason: "Resignation",
};

export interface AbsentiesmData {
  absentiesm: Absentiesm [];
}

export const dummyAbsentiesmData = {
  absentiesm: [{ totalAbsent: 0, year: 0, month: 0 }],
}